/* eslint-disable import/prefer-default-export */
/**
 * PostHog feature-flag getters — the counterpart to growthbook.js.
 *
 * These historically lived in growthbook.js (some flags were migrated off
 * GrowthBook to PostHog with their keys unchanged), which made the file name
 * misleading. They read synchronously through PosthogService so call sites can
 * stay non-reactive; the flag keys themselves live in constants/ff.posthog.js.
 */
import { PosthogService } from './services/posthog';
import { FeatureFlagKeys } from './constants/ff.posthog';

/**
 * Migrated from Growthbook to PostHog (key unchanged) per GOTU-576.
 * Reads synchronously from PostHog to preserve the existing non-reactive
 * call-site behavior. Cleanup tracked in GOTU-3958.
 */
export const getShouldEnablePermanentJobV2 = () =>
  PosthogService.getInstance().isFeatureEnabled(
    FeatureFlagKeys.enablePermanentJobV2AdminPanel,
    false,
  );

/**
 * Gates the Best in Dental cycle admin: its two routes and its rail entry.
 *
 * Read synchronously, matching the Permanent Job V2 gate above — App.js decides
 * which routes to register during render, so an async read would leave a deep
 * link to fall through to the catch-all redirect before the flag arrived.
 *
 * Visibility only. awards-service gates the API on ADMIN_ALLOWLIST_USER_IDS, so
 * an admin with the flag on but not on the allowlist still gets 403s.
 */
export const getShouldEnableBestInDental = () =>
  PosthogService.getInstance().isFeatureEnabled(
    FeatureFlagKeys.bestInDentalAdminPanel,
    false,
  );
